module.exports = __webpack_public_path__ + "img/puberty-decal-22.a70c921e.png";